import './requests-collapse-header.scss';

import dayjs from 'dayjs';

import { ChosenBankStatus } from '@/components/Shared/ui';
import { type TDataSource } from '@/types/dataSource';

interface IProps {
  auto: string;
  dataSource: TDataSource;
  bankInfo: {
    name: string | undefined;
    icon: string | undefined;
  };
}

const RequestsCollapseHeader: React.FC<IProps> = ({
  auto,
  dataSource,
  bankInfo
}) => {
  const totalAlternatives =
    dataSource.status.approvedAlternatives.length +
    dataSource.status.leasingStatus.approvedAlternatives.length;
  const totalApproved =
    dataSource.status.approved.length +
    dataSource.status.leasingStatus.approved.length;
  const totalExpectations =
    dataSource.status.expectations.length +
    dataSource.status.leasingStatus.expectations.length;
  const totalDenied =
    dataSource.status.denied.length +
    dataSource.status.leasingStatus.denied.length;
  const totalErrors =
    dataSource.status.errors.length +
    dataSource.status.leasingStatus.errors.length;

  return (
    <div className="requests-collapse-header">
      <div>
        <div className="requests-collapse-header__flex">
          <h2 className="requests-collapse-header__title">{auto}</h2>
          <span className="requests-collapse-header__separate-dot">&#183;</span>
          <p className="requests-collapse-header__text requests-collapse-header__hidden">
            Инициатор: {dataSource.createdUser}
          </p>
        </div>
        <p className="requests-collapse-header__text">
          {dataSource.loan.dealer}
          <span className="requests-collapse-header__hidden">
            <span className="requests-collapse-header__separate-dot">
              &#183;
            </span>
            {dataSource.loan.amount} ₸
            <span className="requests-collapse-header__separate-dot">
              &#183;
            </span>
            Создано: {dayjs(dataSource?.created_at?.date).format('DD.MM.YYYY')}
          </span>
        </p>
      </div>
      {dataSource.status.isFinanced ? (
        <ChosenBankStatus
          img={bankInfo?.icon}
          name={bankInfo?.name}
          status={{
            code: 'financed',
            name: 'Профинансировано'
          }}
        />
      ) : dataSource.status.isSelected ? (
        <ChosenBankStatus
          img={bankInfo?.icon}
          name={bankInfo?.name}
          status={{ code: 'chosen' }}
        />
      ) : dataSource.status.leasingStatus.isFinanced ? (
        <ChosenBankStatus
          img={
            dataSource.status.leasingStatus.selectedLeasing?.leasingCompany
              .icon || ''
          }
          name={
            dataSource.status.leasingStatus.selectedLeasing?.leasingCompany
              .name || ''
          }
          status={{ code: 'financed', name: 'Профинансировано' }}
          isLeasing
        />
      ) : dataSource.status.leasingStatus.isSelected ? (
        <ChosenBankStatus
          img={
            dataSource.status.leasingStatus.selectedLeasing?.leasingCompany
              .icon || ''
          }
          name={
            dataSource.status.leasingStatus.selectedLeasing?.leasingCompany
              .name || ''
          }
          status={{ code: 'chosen', name: 'Лизинг выбран' }}
          isLeasing
        />
      ) : (
        <div className="requests-collapse-header__flex requests-collapse-header__flex--gap-8">
          {totalApproved > 0 && (
            <div
              className="requests-collapse-header__status"
              style={{
                '--bg-color': '#0CAF60',
                '--text-color': 'white'
              }}
            >
              {totalApproved}
            </div>
          )}
          {totalAlternatives > 0 && (
            <div
              className="requests-collapse-header__status"
              style={{
                '--bg-color': '#2F78EE',
                '--text-color': 'white'
              }}
            >
              {totalAlternatives}
            </div>
          )}
          {totalExpectations > 0 && (
            <div
              className="requests-collapse-header__status"
              style={{
                '--bg-color': '#FFD023',
                '--text-color': '#111827'
              }}
            >
              {totalExpectations}
            </div>
          )}
          {totalDenied > 0 && (
            <div
              className="requests-collapse-header__status"
              style={{
                '--bg-color': '#E03137',
                '--text-color': 'white'
              }}
            >
              {totalDenied}
            </div>
          )}
          {totalErrors > 0 && (
            <div
              className="requests-collapse-header__status"
              style={{
                '--bg-color': '#9321ff',
                '--text-color': 'white'
              }}
            >
              {totalErrors}
            </div>
          )}
          {dataSource.status.isAddedToQueue && (
            <div className="requests-collapse-header__big-status">
              Добавлен в очередь
            </div>
          )}
          {dataSource.status.isUnverified && (
            <div className="requests-collapse-header__big-status requests-collapse-header__big-status--unverified">
              ВАЛИДАЦИЯ ОТП
            </div>
          )}
          {dataSource.status.isDraft && (
            <div className="requests-collapse-header__big-status">ЧЕРНОВИК</div>
          )}
        </div>
      )}
    </div>
  );
};

export default RequestsCollapseHeader;
